angular.module('ihestiaIkomunikator.fullListPanel', [

]);
